export const refreshReduxStore = (state, initial_state) => {
        let key = {};
    
        let stateExist = state && Object.keys(state).length !== 0 && Object.getPrototypeOf(state) === Object.prototype;
        let initialStateExist = initial_state && Object.keys(initial_state).length !== 0 && Object.getPrototypeOf(initial_state) === Object.prototype;
    
        if (stateExist && initialStateExist)
            for (var i in initial_state) {
                if (state[i]) key[i] = state[i];
                else key[i] = initial_state[i];
            }
    
        let keyExist = key && Object.keys(key).length !== 0 && Object.getPrototypeOf(key) === Object.prototype;
    
        if (!keyExist && stateExist) return state;
        else if (!keyExist && initialStateExist) return initial_state;
        else return key;
    };